
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[slug]/[propId]",
      function () {
        return require("private-next-pages/properties/[slug]/[propId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/[slug]/[propId]"])
      });
    }
  